import { useApplicationExportPageProps } from './data';
import { ApplicationExportLayout } from './layouts';
import { LoadingPage } from '~/pages/LoadingPage';
import { ErrorPage, ErrorHandler } from '~/pages/ErrorPage';
import { useWindowDocumentTitle } from '~/lib/useWindowDocumentTitle';
import { ApplicationExportProvider } from './context/ApplicationExportContext';

export function ApplicationExportPage() {
  useWindowDocumentTitle('Application Export');
  const { initialProps, isLoadingInitialProps, isInitialPropsError, initialPropsError } =
    useApplicationExportPageProps();

  if (!isInitialPropsError && isLoadingInitialProps) {
    return <LoadingPage />;
  }
  if (isInitialPropsError) {
    return <ErrorHandler error={initialPropsError} />;
  }
  if (!initialProps) {
    return <ErrorPage customMessage="Failed to fetch page props." />;
  }

  return (
    <ApplicationExportProvider initialProps={initialProps}>
      <ApplicationExportLayout />
    </ApplicationExportProvider>
  );
}
